import { Field, FieldLabel } from '@sara/ui/components/field';
import { Switch } from '@sara/ui/components/switch';

// FUTURE(brand color): the brand-color control is commented out below until we
// can apply a brand color safely in the interview app (light/dark mode +
// contrast). The imports/const below are only used by that control — restore
// them when it comes back.
// import { useEffect, useState } from 'react';
// import { Button } from '@sara/ui/components/button';
// import { FieldContent, FieldError } from '@sara/ui/components/field';
// import { Input } from '@sara/ui/components/input';
// import { HEX_COLOR } from './schemas';
// // Seed for the native color picker thumb when no color is set. NEVER stored or displayed as the value.
// const PICKER_SEED = '#6366F1';

interface CandidateExperienceDefaultsFormProps {
  showOrgLogo: boolean;
  onToggleShowOrgLogo: (next: boolean) => void;
  isPending: boolean;
  // FUTURE(brand color): re-add when the interview app can theme safely.
  // brandColor: string | null;
  // onSaveBrandColor: (next: string | null) => void;
}

export function CandidateExperienceDefaultsForm({
  showOrgLogo,
  onToggleShowOrgLogo,
  isPending,
}: CandidateExperienceDefaultsFormProps) {
  // FUTURE(brand color): local draft + validation for the color control.
  // const [draft, setDraft] = useState<string | null>(brandColor);
  // // Reconcile local edits with the server value after a successful save/refetch.
  // useEffect(() => setDraft(brandColor), [brandColor]);
  // const isEmpty = draft === null || draft === '';
  // const isValid = isEmpty || HEX_COLOR.test(draft);
  // const isDirty = (draft === '' ? null : draft) !== brandColor;
  // const canSave = !isPending && isDirty && isValid;

  // FUTURE(brand color): control deferred until the interview app can apply a
  // brand color safely across light/dark mode + contrast. Full markup retained
  // in the block comment below the component. When it returns this control will
  // need its own home (it no longer fits the Logo card header).
  return (
    <Field orientation="horizontal" className="w-auto items-center gap-2.5">
      <FieldLabel
        htmlFor="show-org-logo"
        className="cursor-pointer text-[13px] font-medium text-foreground"
      >
        Shown to candidates
      </FieldLabel>
      <Switch
        id="show-org-logo"
        checked={showOrgLogo}
        onCheckedChange={onToggleShowOrgLogo}
        disabled={isPending}
      />
    </Field>
  );
}

/* FUTURE(brand color): the deferred brand-color control. Paste back into the
   return above and restore the imports/draft logic + props at the top.

<Field data-invalid={(!isValid && !isEmpty) || undefined}>
  <FieldLabel htmlFor="brand-color-hex" className="text-[13px] font-medium text-foreground">
    Brand color (hex)
  </FieldLabel>
  <FieldContent>
    <div className="flex items-center gap-3">
      // swatch reflects the draft; null/empty paints nothing (never #000000)
      <span
        data-testid="brand-color-swatch"
        data-empty={isEmpty || undefined}
        aria-hidden
        className={
          isEmpty
            ? 'h-9 w-9 shrink-0 rounded-md border border-dashed bg-muted'
            : 'h-9 w-9 shrink-0 rounded-md border'
        }
        style={isEmpty ? undefined : { backgroundColor: draft as string }}
      />
      <input
        type="color"
        aria-label="Pick brand color"
        value={isEmpty ? PICKER_SEED : (draft as string)}
        onChange={(e) => setDraft(e.target.value)}
        disabled={isPending}
        className="h-9 w-12 shrink-0 cursor-pointer rounded-md border bg-transparent p-1"
      />
      <Input
        id="brand-color-hex"
        placeholder="#4F46E5"
        value={draft ?? ''}
        onChange={(e) => setDraft(e.target.value === '' ? null : e.target.value)}
        disabled={isPending}
        aria-invalid={!isValid && !isEmpty}
        autoComplete="off"
        className="max-w-[10rem]"
      />
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => setDraft(null)}
        disabled={isPending || isEmpty}
      >
        Clear
      </Button>
      <Button
        type="button"
        variant="tinted"
        shape="pill"
        size="sm"
        onClick={() => onSaveBrandColor(draft === '' ? null : draft)}
        disabled={!canSave}
      >
        {isPending ? 'Saving…' : 'Save'}
      </Button>
    </div>
    {!isValid && !isEmpty && (
      <FieldError errors={[{ message: 'Enter a 6-digit hex color like #4F46E5' }]} />
    )}
  </FieldContent>
</Field>
*/
